import { createEntityAdapter } from '@reduxjs/toolkit';

import type { ILevel } from '@/Module/Grade/Model/DataModel';

export const levelAdapter = createEntityAdapter<ILevel>({
  selectId: model => model.id,
});
